//Builds a ConversationTranscriber that records from the default mic. Returns an async stop handle.
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import type { Utterance } from "../types/utterance";

interface Options {
  onUtterance: (u: Utterance) => void;
  onComplete: (fullText: string) => void;
  langs: string[];
  onError?: (err: Error) => void;
}

export async function runAzureLiveTranscribe(opts: Options) {
  // 1. Get mic stream
  const speechCfg = SpeechSDK.SpeechConfig.fromSubscription(
    import.meta.env.VITE_SPEECH_KEY!,
    import.meta.env.VITE_SPEECH_REGION!
  );
  /* speechCfg.speechRecognitionLanguage = "en-US";
  speechCfg.setProperty(
    SpeechSDK.PropertyId.SpeechServiceConnection_SpeakerIdMode,
    "Conversation"
  ); */
  // ► continuous speaker diarisation + language-ID
  speechCfg.setProperty(
    SpeechSDK.PropertyId.SpeechServiceConnection_SpeakerIdMode,
    "Conversation"
  );
  speechCfg.setProperty(
    SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode,
    "Continuous"
  );

  const lidCfg = SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(
    opts.langs
  );
  speechCfg.setProperty("SpeechServiceConnection_SpeakerCount", "2");

  // Built-in mic capture, SDK handles resampling & WebSocket stream
  const audioCfg = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
  //const rec = new SpeechSDK.ConversationTranscriber(speechCfg, audioCfg);
  const rec = SpeechSDK.ConversationTranscriber.FromConfig(
    speechCfg,
    lidCfg,
    audioCfg
  );

  const buffer: string[] = [];

  rec.transcribed = (_, e) => {
    const spk = e.result.speakerId ?? "(no-ID)";
    const lang = e.result.language ?? "(detecting…)";
    console.log(
      "transcribed:",
      e.result.text,
      "speaker:",
      spk,
      "lang:",
      lang
    );
    if (!e.result.text) return; // skip blanks
    const sid = parseInt(e.result.speakerId?.replace(/\D/g, ""), 10);
    //opts.onUtterance({ speaker: sid, text: e.result.text, start: 0, end: 0 });
    opts.onUtterance({
      speaker: sid,
      text: e.result.text,
      lang: e.result.language,
      start: 0,
      end: 0,
    });
    buffer.push(e.result.text);
  };

  rec.sessionStopped = () => {
    opts.onComplete(buffer.join(" "));
    rec.stopTranscribingAsync();
  };
  rec.canceled = (_, ev) => {
    if (ev.reason === SpeechSDK.CancellationReason.Error && opts.onError) {
      opts.onError(new Error(ev.errorDetails));
    }
    // else EndOfStream → ignore
  };

  rec.startTranscribingAsync();
  /* Return a “stop” handle so UI can end the session manually */
  return () =>
    new Promise<void>((resolve) => {
      rec.stopTranscribingAsync(
        () => {
          resolve();
        },
        (err) => {
          console.error("stopTranscribingAsync", err);
          resolve();
        }
      );
    });
}
